import { render, staticRenderFns } from "./ResSelectUpdateHeader.vue?vue&type=template&id=5f6673d0&scoped=true"
import script from "./ResSelectUpdateHeader.vue?vue&type=script&lang=js"
export * from "./ResSelectUpdateHeader.vue?vue&type=script&lang=js"
import style0 from "./ResSelectUpdateHeader.vue?vue&type=style&index=0&id=5f6673d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6673d0",
  null
  
)

export default component.exports